export default __webpack_public_path__ + "static/media/_DSC0394.fa43786d.JPG";